export default __webpack_public_path__ + "static/media/kitchen5-afterB-1024w.745b1e33.png";